import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { SharedCare } from "@/@types/esus/SharedCare";

type IndicatorEmultiM2SharedCareHistoryItemProps = {
	sharedCare: SharedCare;
};

export function IndicatorEmultiM2SharedCareHistoryItem({
	sharedCare,
}: Readonly<IndicatorEmultiM2SharedCareHistoryItemProps>) {
	return (
		<>
			<Row>
				<Col>
					<p>
						<span className="fw-bold text-primary">Equipe solicitante: </span>
						{sharedCare.requesterHealthTeam?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="fw-bold text-primary">Unidade solicitante: </span>
						{sharedCare.requesterHealthUnit?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Profissional solicitante: </span>
						{sharedCare.requesterProfessional?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">
							Categoria do profissional solicitante:{" "}
						</span>
						{sharedCare.requesterCbo?.description?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="fw-bold text-primary">Equipe executante: </span>
						{sharedCare.performerHealthTeam?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="fw-bold text-primary">Unidade executante: </span>
						{sharedCare.performerHealthUnit?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Profissional executante: </span>
						{sharedCare.performerProfessional?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">Categoria do profissional executante: </span>
						{sharedCare.performerCbo?.description?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
		</>
	);
}
